require('./_wks-define')('observable');


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/~/core-js/modules/es7.symbol.observable.js
// module id = k8JO
// module chunks = 1